import React from 'react';
import { motion } from 'framer-motion';
const newsItems = [{
  image: 'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=600&q=80',
  title: 'TM44 Compliance: What You Need to Know Before the Fines',
  date: '2026-04-05',
  category: 'Guide'
}, {
  image: 'https://images.unsplash.com/photo-1573164713988-8665fc963095?w=600&q=80',
  title: 'Daikin vs Generic Warranties: Why It Matters for Your Business',
  date: '2026-03-28',
  category: 'FAQ'
}, {
  image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=600&q=80',
  title: 'Ventilation Requirements by Sector: Office, Retail & Hospitality',
  date: '2026-03-15',
  category: 'Article'
}];
export function News() {
  return <section className="py-24 bg-[#D4DDE8]" data-id="element-130">
      <div className="container mx-auto px-6" data-id="element-131">
        <div className="flex justify-between items-end mb-12" data-id="element-132">
          <h2 className="text-4xl md:text-5xl font-serif" data-id="element-133">Knowledge Hub</h2>
          <a href="#" className="hidden md:flex items-center gap-2 text-sm font-medium hover:text-accent transition-colors group" data-id="element-134">
            View all resources
            <img src="https://cdn.magicpatterns.com/uploads/okbpmyBbWVyrbcmsCAB9cm/arrow-right-navy.svg" alt="" className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-135" />
          </a>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-136">
          {newsItems.map((item, index) => <motion.a href="#" key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="group block" data-id="element-137">
              <div className="relative aspect-[4/3] rounded-xl overflow-hidden mb-6" data-id="element-138">
                <img src={item.image} alt={item.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-139" />
              </div>
              <h3 className="text-lg font-medium mb-4 group-hover:text-accent transition-colors line-clamp-2" data-id="element-140">
                {item.title}
              </h3>
              <div className="flex items-center gap-3 text-xs text-primary-dark/50 uppercase tracking-wider" data-id="element-141">
                <span data-id="element-142">{item.date}</span>
                <span className="w-1 h-1 bg-primary-dark/20 rounded-full" data-id="element-143"></span>
                <span data-id="element-144">{item.category}</span>
              </div>
            </motion.a>)}
        </div>

        <div className="mt-8 md:hidden flex justify-center" data-id="element-145">
          <a href="#" className="flex items-center gap-2 text-sm font-medium hover:text-accent transition-colors group" data-id="element-146">
            View all resources
            <img src="https://cdn.magicpatterns.com/uploads/okbpmyBbWVyrbcmsCAB9cm/arrow-right-navy.svg" alt="" className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-147" />
          </a>
        </div>
      </div>
    </section>;
}